const formatMoney = (amount: number) => {
    if (amount === undefined) {
      return 0;
    }
    const cash = Math.round(amount / 10) * 10;
    if (cash === undefined) {
      return 0;
    }
  
    return amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };
  
  export default formatMoney